<template>
  <filter-summary
    icon="item"
    title="商品分類"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
    >{{ count }}{{ label }}</filter-summary
  >
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品分類の分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    categories: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    selectMode: {
      type: String,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    count() {
      if (this.selectMode === 'category') {
        return this.categories.length
      } else if (this.selectMode === 'item') {
        return this.items.length
      }
      return undefined
    },
    label() {
      if (this.selectMode === 'category') {
        return '分類'
      } else if (this.selectMode === 'item') {
        return '商品'
      }
      return undefined
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
